import { createContext, useContext } from "react";

export type TabsContextType = {
  activeTab: number | string;
  setActiveTab: (value: number | string) => void;
  fullWidth?: boolean;
  tiny?: boolean; // Ajout de tiny dans le contexte
};

// Create context
export const TabsContext = createContext<TabsContextType | undefined>(undefined);

// Context hook
export const useTabsContext = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("Tab components must be used within a GenericTabs component");
  }
  return context;
};



